<template>
  <nav
    :class="{'menu-open': isMenuOpen}"
    class="DashboardNavigation Dashboard-mobile"
    @click="toggleMenu"
  >
    <span
      :class="{'Icon-chevron-up': isMenuOpen === true}"
      class="far fa-chevron-down"
    />
    <a
      href="#"
      class="Account-secondaryMenuLink"
    >
      <span class="Account-secondaryLabel">Dashboard Menu</span>
    </a>
    <div v-if="isMenuOpen">
      <router-link
        :to="{ name: 'MyHub' }"
        class="Account-secondaryMenuLink"
      >
        <span class="Account-secondaryLabel">My Hub</span>
      </router-link>

      <router-link
        :to="{ name: 'SavedItems' }"
        class="Account-secondaryMenuLink Account-secondaryMenuLink--company"
      >
        <span class="Account-secondaryLabel">Saved Items</span>
      </router-link>

      <!-- TODO readd saved searches  -->

      <router-link
        :to="{ name: 'reviews' }"
        class="Account-secondaryMenuLink"
      >
        <span class="Account-secondaryLabel">My Reviews</span>
      </router-link>

      <router-link
        :to="{ name: 'contact-preferences' }"
        class="Account-secondaryMenuLink"
      >
        <span class="Account-secondaryLabel">Contact Preferences</span>
      </router-link>

      <router-link
        :to="{ name: 'basic-info' }"
        class="Account-secondaryMenuLink"
      >
        <span class="Account-secondaryLabel">Personal Info</span>
      </router-link>

      <router-link
        :to="{ name: 'data-security' }"
        class="Account-secondaryMenuLink"
      >
        <span class="Account-secondaryLabel">Data & Security</span>
      </router-link>
    </div>
  </nav>
</template>
<script>
export default {
  data() {
    return {
      isMenuOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../scss/abstracts/abstracts";
$dashboardHeaderBreak: 1025px;
.Dashboard-mobile {
  @include customMediaQuery(min-width, $dashboardHeaderBreak) {
    display: none;
  }

  position: absolute;
  top: 50px;
      @media (min-width: 768px) {
        top: 69px;
      }
  right: 0;
  display: block;
  z-index:1;
  /*flex-direction: column;*/
  background-color: color($primary-color);
  // @include respond-to(md, max-width) {
  //   @include z-index(content);
  // }
  width: 100%;
  color: white;
  overflow: hidden;
  height: 54px;
  line-height: 42px;

 .Account-secondaryLabel {
    color: white;
  }
  // @include customMediaQuery(max-width, $headerBreak) {
  //   position: absolute;
  //   top: 0px;
  // }

  /* @include respond-to(md) {
    display: none;
  } */

      &.menu-open {
        height: auto;
      }

      .Account-secondaryMenuLink {
        margin-left: 20px;
        width: 305px;
        padding: 3px 0;
      }

      .Menu-icon {
        height: 2px;
        background-color: white;
        display: inline;
        position: absolute;
        width: 20px;
        top: 24px;
        left: 17px;
      }
      .far {
        width: 16%;
        text-align: center;
        padding-top: 17px;
        display: block;
        position: absolute;
        right: 0;
        top: -1px;
      }

      .router-link-active {
        background-color: transparent;
        border: none;
        width: 56%;
        margin-top: -4px;
      }

}
</style>
